import type { SchemaField, SyncrelState } from "./types";
import { frameworkCatalog, frameworkTemplate } from "./framework-manager";
import { migrateLegacyFieldReferences } from "./state-migrations";

const frameworkFieldKeys = new Set(
  frameworkCatalog.flatMap((framework) => framework.fields.map((field) => field.key)),
);

export const activeFrameworkFields = (state: SyncrelState): SchemaField[] => {
  const cleanState = migrateLegacyFieldReferences(state);
  const active = cleanState.workspace.activeFramework;
  if (!active) return uniqueFields(cleanState.schema.fields);

  const stateFieldByKey = new Map(cleanState.schema.fields.map((field) => [field.key, field]));
  const templateFields = frameworkTemplate(active).fields.map((field) => ({
    ...field,
    ...stateFieldByKey.get(field.key),
  }));
  const customFields = cleanState.schema.fields.filter((field) => !frameworkFieldKeys.has(field.key));
  return uniqueFields([...templateFields, ...customFields]);
};

const uniqueFields = (fields: SchemaField[]): SchemaField[] => {
  const byKey = new Map<string, SchemaField>();
  for (const field of fields) byKey.set(field.key, field);
  return Array.from(byKey.values());
};
